<template>
  <div class="searchContainer">
    <input
      :placeholder="placeholder || 'Search Website'"
      type="search"
      @input="onInput"
      v-on:keydown.enter="enterPressed"
      ref="searchBox"
    >
    <div class="searchIconContainer" @click="searchClicked">
      <SearchIcon class="searchIcon"/>
    </div>
  </div>
</template>

<script>
import SearchIcon from "@/assets/img/search.svg";

export default {
  name: 'SearchBar',
  components: {
      SearchIcon

  },
  props:["placeholder", "searchFunc"],
  mounted(){
      if(this.$route.query.search){
          this.$refs.searchBox.value = this.$route.query.search;
      }
  },
  methods:{
      searchClicked(){
          this.searchFunc(this.$refs.searchBox.value);
      },
      onInput(){
          this.searchFunc(this.$refs.searchBox.value);
      },
      enterPressed(){
          document.activeElement.blur();  //close keyboard on mobile devices 
          this.searchFunc(this.$refs.searchBox.value);
      },
      clear(){
        this.$refs.searchBox.value = '' 
      }
  }
}
</script>

<style lang="scss" scoped>

$searchButtonWidth: 40px;
.searchContainer{
    position:relative;
  input {
    border: 1px $CTgrey solid;
    width: calc(100% - #{$searchButtonWidth});
    height: 30px;
    padding: 4px;
  }
  .searchBarContainer{
    position:relative;
  }

  .searchIconContainer{
    background:black;
    width: $searchButtonWidth;
    display:inline-block;
    position:absolute;
    right:0;
    top:0;
    bottom:0;

    //vertical align
    padding-top:3px;
    text-align:center;
    vertical-align: middle;
  }

  .searchIcon{
    color:white;
    fill:white;
    height:100%;
    padding:2px;
  }
}

</style>



